import React from "react";
import { FoleySignalsStore } from "$stores/foleySignals";
import { getTerm } from "$stores/dictionary";
import { formatDate, SHORT_DATE_FORMAT } from "$utils/date-helpers";

const SignalsColumn = ({ tooltip, header, items }) => (
    <div className="foley-signals-col">
        <h5 className="txt -uppercase">
            <span data-tooltip={tooltip}>{header}</span>
        </h5>
        <ol className="foley-signals-list">
            {items.map((item) => (
                <li key={item.code}>
                    <span data-tooltip={item.label}>{item.label}</span>
                </li>
            ))}
        </ol>
    </div>
);

const FoleyExpansionSignals = () => {
    const { pg, sector, periodYear, periodMonth, isLoading } =
        FoleySignalsStore.useState((s) => s);

    const hasData = pg.length > 0 || sector.length > 0;
    if (isLoading || !hasData) {
        return null;
    }

    const hasPeriod = !!periodYear && !!periodMonth;
    const periodLabel = hasPeriod
        ? formatDate(new Date(periodYear, periodMonth - 1, 1), SHORT_DATE_FORMAT)
        : null;

    return (
        <div className="foley-expansion-signals">
            <div className="flex-header">
                <h3 className="txt -uppercase -no-margin -tablet-center">
                    <em>Foley</em>{" "}
                    <span data-tooltip={getTerm("tooltipFoleyExpansionSignals")}>
                        {getTerm("expansionSignals")}
                    </span>
                </h3>
                {hasPeriod && (
                    <span className="foley-signals-period">
                        {getTerm("foleyDataAsOf")} {periodLabel}
                    </span>
                )}
            </div>
            <div className="foley-signals-columns">
                {pg.length > 0 && (
                    <SignalsColumn
                        tooltip={getTerm("tooltipFoleyPracticeGroups")}
                        header={getTerm("foleyPracticeGroupsHeader")}
                        items={pg}
                    />
                )}
                {sector.length > 0 && (
                    <SignalsColumn
                        tooltip={getTerm("tooltipFoleySectors")}
                        header={getTerm("foleySectorsHeader")}
                        items={sector}
                    />
                )}
            </div>
        </div>
    );
};

export default FoleyExpansionSignals;
